import React from "react";

import { Link } from "react-router-dom";

function Auth() {
  return (
    <div id="navbtn" className="nav__buttons">
      <Link to="/login" id="loginbtn" className="nav__btn-link">
        <button className="button-primary nav__btn nav__btn--login">
          Log In
        </button>
      </Link>
      <Link to="/signup" className="nav__btn-link">
        <button className="button-primary-blue nav__btn nav__btn--signup">
          Sign Up
        </button>
      </Link>
    </div>
  );
}

export default Auth;
